export default __webpack_public_path__ + "static/media/kve.81a10a9c.jpg";